import React, { useCallback, useEffect, useRef, useState } from 'react'
import { IMaskInput } from 'react-imask'
import { Form } from 'react-bootstrap'

const PhoneMask = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props
  return (
    <IMaskInput
      placeholder='Введите номер телефона'
      {...other}
      mask='+7 (#00) 000-0000'
      definitions={{
        '#': /[9]/,
      }}
      ref={ref}
      onAccept={(value) => onChange(value)}
      overwrite
    />
  )
})

const isPhoneBegining = (text) => {
  if (text.length < 3) {
    return false
  } else {
    const begining = text.slice(0, 3)

    if (begining === '+79') return true
    if (begining[0] === '8' && begining[1] === '9') return true
    if (begining[0] === '7' && begining[1] === '9') return true
    if (begining[0] === '9' && !isNaN(parseInt(begining[1]))) return true

    return false
  }
}

const normalize = (value_) => {
  return value_
    .replace(' ', '')
    .replace('+7', '')
    .replace('(', '')
    .replace(') ', '')
    .replace('-', '')
}

export default function LoginPhoneInput({
  value: valueProp,
  onlyPhone,
  isRequired,
  onChange,
  onEntered,
  style,
}) {
  const [value, setValue] = useState('')
  const [isFirstInput, setIsFirstInput] = useState(true)
  const [isValid, setIsValid] = useState(false)
  const [isPhoneNumber, setIsPhoneNumber] = useState(false)
  const inputPhoneRef = useRef(null)
  const inputLoginRef = useRef(null)

  const handleChangePhone = useCallback(
    (value_) => {
      if (!isPhoneNumber) {
        return
      }

      if (value_.length === 0) {
        setIsPhoneNumber(false)
        onChange('')
        onEntered('')
        return
      }

      const normalizedValue = normalize(value_)
      // console.log('set value ph', value_)
      setValue(normalizedValue)

      if (normalizedValue.length === 10) {
        onEntered(normalizedValue)
        onChange(normalizedValue)
        setIsValid(true)
        setIsFirstInput(false)
      } else {
        onChange('')
        onEntered('')
        setIsValid(false)
      }
    },
    [isPhoneNumber, onChange, onEntered]
  )

  const handleChangeValue = useCallback(
    (value_) => {
      setValue(value_)
      onChange(value_)
      if (isPhoneBegining(value_)) {
        setIsPhoneNumber(true)
      } else {
        onEntered(value_)
        setIsValid(value_.length !== 0)
      }
    },
    [onChange, onEntered]
  )

  const handleChangeEvent = useCallback(
    (event) => {
      const value_ = event.target.value
      handleChangeValue(value_)
    },
    [handleChangeValue]
  )

  const handleBlur = useCallback(() => {
    if (value.length === 0) setIsValid(false)
  }, [value])

  const getClassName = useCallback(() => {
    if (isValid) return 'form-control is-valid'
    if (isRequired) return 'form-control is-invalid'
    else return 'form-control'
  }, [isRequired, isValid])

  useEffect(() => {
    if (valueProp !== undefined && valueProp !== '') {
      // console.log('valueProp', valueProp)
      // setIsPhoneNumber(true)
      handleChangeValue(valueProp)
    }
  }, [onlyPhone, valueProp, handleChangeValue])

  useEffect(() => {
    // здесь творится магия, потому что у нас два компонента - один для ввода номера, другой - для ввода логина
    // если не только телефон - то есть вход, а не регистрация, то смотрим,
    // если сейчас вводится номер телеофна, то активируется компонент для ввода телефона, иначе для ввода логина
    // а если у нас вводится только телефон - то есть регистранция, то активируем компонент для ввода телефона,
    // и ставим флаг, что вводится номер
    if (!onlyPhone) {
      if (isPhoneNumber) {
        inputPhoneRef.current.element.focus()
      } else {
        inputLoginRef.current.focus()
      }
    } else {
      inputPhoneRef.current.element.focus()
      setIsPhoneNumber(true)
    }
  }, [onlyPhone, isPhoneNumber])

  return (
    <>
      {onlyPhone ? (
        <PhoneMask
          key='phone_mask'
          ref={inputPhoneRef}
          value={value}
          type='text'
          className={getClassName()}
          onChange={handleChangePhone}
          onBlur={handleBlur}
        />
      ) : (
        <>
          <PhoneMask
            key='phone_mask'
            ref={inputPhoneRef}
            value={value}
            type='text'
            className={getClassName()}
            onChange={handleChangePhone}
            onBlur={handleBlur}
            style={{ display: isPhoneNumber ? 'block' : 'none' }}
          />
          <Form.Control
            ref={inputLoginRef}
            type='text'
            value={value}
            placeholder={'Номер телефона или логин Freedom'}
            onChange={handleChangeEvent}
            maxLength={20}
            className={
              isFirstInput || !isRequired
                ? ''
                : value.length === 0
                ? 'is-invalid'
                : 'is-valid'
            }
            onBlur={handleBlur}
            required
            style={{
              borderRadius: '0px',
              zIndex: '2',
              display: !isPhoneNumber ? 'block' : 'none',
            }}
          />
          {/**/}
        </>
      )}
      <div
        className='invalid-feedback'
        style={{ display: !isFirstInput && !isValid && isRequired ? 'block' : 'none' }}
      >
        Введите номер телефона {!onlyPhone && 'или логин Freedom'}
      </div>
    </>
  )
}
